import * as React from 'react';
import type { SVGProps } from 'react';
const SvgRefresh = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 0 20 20"
    {...props}
  >
    <path d="M4.5 9.818A5.494 5.494 0 0 1 10 4.329c1.719 0 3.254.787 4.263 2.02H13.24a.688.688 0 0 0 0 1.376h2.763c.38 0 .687-.308.687-.688v-2.77a.687.687 0 1 0-1.375 0v1.005A6.99 6.99 0 0 0 10 2.829c-3.864 0-7 3.128-7 6.989s3.136 6.989 7 6.989a7 7 0 0 0 6.74-5.095.75.75 0 1 0-1.445-.406 5.5 5.5 0 0 1-5.295 4 5.494 5.494 0 0 1-5.5-5.488" />
  </svg>
);
export default SvgRefresh;
